import { type Components, switchClasses, type Theme } from '@mui/material'

/**
 * Note: `size` and `color` props are not expected and not respected.
 */
export const MuiSwitch: Components<Theme>['MuiSwitch'] = {
    styleOverrides: {
        root: ({ theme }) => ({
            width: 36,
            height: 20,
            padding: 0,
            marginRight: theme.spacing(2), // gap before a trailing label
            overflow: 'visible',

            [`& .${switchClasses.track}`]: {
                borderRadius: 12,
                backgroundColor: theme.palette.grey[100],
                opacity: 1,
            },

            [`& .${switchClasses.thumb}`]: {
                width: 16,
                height: 16,
                boxShadow: theme.shadows[1],
            },

            [`& .${switchClasses.switchBase}`]: {
                padding: 2,
                color: theme.palette.common.white,

                [`&.Mui-focusVisible + .${switchClasses.track}`]: {
                    outline: `2px solid ${theme.palette.primary[700]}`,
                    outlineOffset: 2,
                    borderRadius: 12,
                },

                // --- OFF states ---
                [`&:hover + .${switchClasses.track}`]: {
                    backgroundColor: theme.palette.grey[200],
                },

                [`&.${switchClasses.disabled}`]: {
                    [`& + .${switchClasses.track}`]: {
                        opacity: 1,
                    },
                    [`& .${switchClasses.thumb}`]: {
                        backgroundColor: theme.palette.grey[50],
                    },
                },

                // --- ON states ---
                [`&.${switchClasses.checked}`]: {
                    transform: 'translateX(16px)',
                    color: theme.palette.common.white,
                    // default
                    [`& + .${switchClasses.track}`]: {
                        backgroundColor: theme.palette.primary[700],
                        opacity: 1,
                    },
                    // hover
                    [`&:hover + .${switchClasses.track}`]: {
                        backgroundColor: theme.palette.primary[600],
                    },
                    // disabled
                    [`&.${switchClasses.disabled} + .${switchClasses.track}`]: {
                        backgroundColor: theme.palette.primary[100],
                        opacity: 1,
                    },
                },
            },
        }),
    },
}
